import React from 'react';

import { NoInvoicesContainer } from './InvoicesDisplayed.styled';
import { Text } from 'components/v2/Typography/Text';
import Invoice from 'screens/Invoices/types/invoice';

import { InvoiceCardList } from '../InvoiceCardList/InvoiceCardList';

export const InvoicesDisplayed = ({
  hasUnappliedPaymentsTotalCents,
  invoices,
  onInvoiceSelected,
  onViewInvoice
}: {
  hasUnappliedPaymentsTotalCents: boolean;
  invoices: Invoice[];
  displayAsTable: boolean;
  onInvoiceSelected: (invoice: Invoice) => void;
  onViewInvoice: (invoice: Invoice) => void;
}) => {
  if (invoices.length === 0)
    return (
      <NoInvoicesContainer>
        <Text tag="span" fontStyle="medium">
          There are currently no invoices on your account. <br />
          We will send you an email if there is any financial activity or please check back at a
          later time.
        </Text>
      </NoInvoicesContainer>
    );
  return (
    <InvoiceCardList
      hasUnappliedPaymentsTotalCents={hasUnappliedPaymentsTotalCents}
      invoices={invoices}
      onPayInvoice={invoice => onInvoiceSelected(invoice)}
      onViewInvoice={invoice => onViewInvoice(invoice)}
    />
  );
};
